import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, {useCallback, useEffect, useState } from "react";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import EventBus from "../../EventBus";
import CkMuiDialog from "./CkMuiDialog/CkMuiDialog";
import { CustomSnackbarTypes } from "./CustomSnackBar";
import ChefForPartyService from "../../services/ChefForPartyService";
import { getReasonCategory } from "./constants/constant";
import ReasonSubreasonModuleEnum from "../../enums/ReasonSubreasonModuleEnum";
import { ActionTypeEnum } from "../../enums/ActionTypeEnum";

const partyService = new ChefForPartyService();

interface InputProps {
  isOpen: boolean;
  data: any;
  setCommentData: (data : any) => void;
  setIsOpen: (isOpen: boolean) => void;
  refresh: () => void;
}

const AddPartyAllocationComment = ({
  isOpen,
  setIsOpen,
  setCommentData,
  data,
  refresh,
}: InputProps) => {
  const {allocationId} = data || {}; 
  const [categoryItems,setCategoryItems]=useState<any>([])
  const [reasonCategory, setReasonCategory] = useState<any>(null);
  const [reasonSubCategory, setReasonSubCategory] = useState<string | null>(null);
  let handleClose = () => {
      setReasonCategory(null);
      setReasonSubCategory(null);
      setIsOpen(false);
  };

  const handleReasonCategoryChange = (event: any) => {
      setReasonCategory(event.target.value);
  }

  const handleReasonSubCategoryChange = (event: any) => {
      setReasonSubCategory(event.target.value);
  }

  function showSubCategoryOrNot(reasonCategory: string) {
      if (reasonCategory === "Other") {
        return (
            <FormControl style={{ width: 500 }}>
                <TextField value={reasonSubCategory} onChange={handleReasonSubCategoryChange} label="Write a comment" />
            </FormControl>
        )
      }
      return null;
  }

  const loadData = useCallback(async () => {
    const sampleReasonSubReason = await getReasonCategory(ReasonSubreasonModuleEnum.CHEF_FOR_PARTY,ActionTypeEnum.ALLOCATION_PARTY_COMMENT);
    setCategoryItems(sampleReasonSubReason);
  }, []);

  useEffect(()=>{
    loadData();
  },[loadData])  
  const handleSubmit = () => {
    let comment: any = "";
    if(reasonCategory === 'Other') {
      comment = reasonSubCategory;
    } else {
      comment = reasonCategory;
    }
    if (comment) {
      partyService
        .addAllocationComment(allocationId, { comment: comment })
        .then((res) => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Comment Added Successfully",
            type: CustomSnackbarTypes.SUCCESS,
          });
        })
        .catch(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Something Went Wrong",
            type: CustomSnackbarTypes.ERROR,
          });
        })
        .finally(() => {
          setIsOpen(false);
          refresh();
        });
    }
  };
  return (
    <CkMuiDialog
      isDialogOpen={isOpen}
      setDialogOpen={setIsOpen}
      onDialogClose={handleClose}
      title={"Add Comment"}
      primaryLabel={"Submit"}
      primaryAction={handleSubmit}
      secondaryLabel={"Close"}
      secondaryAction={() => {
        setIsOpen(false);
        setCommentData(null);
      }}
      isLoading={false}
      fullWidth={true}
    >
      <Grid
        container
        spacing={2}
        justifyContent={"space-evenly"}
        style={{ padding: "12px 12px 12px 12px" }}
        direction="column"
        alignItems="center"
    >
        <Grid item xs={12}>
            <FormControl style={{ width: 500 }}>
                <InputLabel id="select-label">Select Comment</InputLabel>
                <Select
                    labelId="select-label"
                    id="select-label"
                    defaultValue="Select a reason"
                    value={reasonCategory}
                    onChange={handleReasonCategoryChange}
                >
                    {categoryItems.map((item: any) => {
                      return (
                        <MenuItem key={item.category} value={item.category}>
                          {item.category}
                        </MenuItem>
                      );
                    })}
                </Select>
            </FormControl>
        </Grid>
        <Grid item xs={12}>
            {
                showSubCategoryOrNot(reasonCategory!)
            }
        </Grid>
              </Grid>
    </CkMuiDialog>
  );
};

export default AddPartyAllocationComment;